// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footer__cN8rv {
    box-shadow: 0px 0px 10px 10px #0000002b;
}
.footer_footerLink__g658r {
    display: flex;
    align-items: center;
    gap: 11px;
}

.footer_copyrightContainer__lkRt8 {
    padding: 11px 0px;
    background-image: linear-gradient(to right, #2acdc2, #63c15f);
    margin-top: 28px;
}
.footer_copyrightContainer__lkRt8 a {
    text-decoration: none;
    color: black;
}

.footer_copyright__QfEx5 {
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 500;
    padding: 0 25px;
}
.footer_copyright__QfEx5 span {
    font-size: 20px;
    font-weight: bold;
}

.footer_linkContainer__1Yb50 {
    display: flex;
    align-items: center;
    gap: 28px;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    margin-top: 40px;
    flex-wrap: wrap;
}
.footer_linkContainer__1Yb50 p a {
    text-decoration: none;
    color: black;
}
.footer_linkContainer__1Yb50 span {
    font-size: 33px;
    position: relative;
    top: -8px;
}
.footer_border1__SlegL {
    display: block;
    margin: 0px auto;
    width: 75%;
    position: relative;
    top: -12px;
}
.footer_border2__E4q0u {
    display: none;
}
.footer_mainContainer__MJOLd {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10%;
}
.footer_call__zE3uC {
    font-size: 25px;
    font-weight: bold;
    color: #69bf4a;
    margin-bottom: 0;
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
}
.footer_call__zE3uC a {
    color: #69bf4a;
    text-decoration: none;
    cursor: pointer;
}
.footer_text__mNIpU {
    font-size: 25px;
    font-weight: bold;
    color: #21ceca;
    margin-bottom: 0;
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
}
.footer_text__mNIpU a {
    color: #21ceca;
    text-decoration: none;
    cursor: pointer;
}
.footer_email__EGu1B {
    color: #060606;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0;
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 10px;
}
.footer_email__EGu1B a {
    color: #060606;
    text-decoration: none;
    cursor: pointer;
}
.footer_email__EGu1B img {
    width: 22px;
    padding-left: 2px;
}
.footer_call__zE3uC span, .footer_text__mNIpU span {
    font-weight: 400;
    font-size: 18px;
}
.footer_pipe__n5Pnj {
    font-size: 12px;
}

@media (hover: hover) and (pointer: fine) {
    .footer_copyrightContainer__lkRt8 a {
        transition: color 0.3s ease;
    }
    .footer_copyrightContainer__lkRt8 a:hover {
        color: white;    
    }
    .footer_linkContainer__1Yb50 p a {
        transition: color 0.3s ease;
    }
    .footer_linkContainer__1Yb50 p a:hover {
        color: #21ceca;
    }
}

@media (hover: none) and (pointer: coarse) {
    .footer_copyrightContainer__lkRt8 a:active {
        color: white;
    }
    .footer_linkContainer__1Yb50 p a:active {
        color: #21ceca;
    }
}

@media screen and (max-width: 768px) {
    .footer_logo__Iuxzz {
        width: 22%;
    }
    .footer_pipe__n5Pnj {
        display: none;
    }
    .footer_copyright__QfEx5 {
        font-size: 12px;
        flex-direction: column;
        gap: 5px;
    }
    .footer_copyrightText__FoVj0 {
        font-size: 12px;
        text-align: center;
    }
    .footer_linkContainer__1Yb50 {
        font-size: 14px;
        padding: 0 60px;
        gap: 8px;
        line-height: 0;
    }
    .footer_border1__SlegL {
        top: 0;
    }
    .footer_border2__E4q0u {
        display: block;
        margin: 0px auto;
        width: 75%;
        position: relative;
        margin-top: 21px;
    }
    .footer_mainContainer__MJOLd {
        gap: 6%;
        flex-direction: column;
        margin-top: 16px;
    }
    .footer_centerLine__567Rs {
        display: none;
    }
    .footer_call__zE3uC, .footer_text__mNIpU, .footer_email__EGu1B {
        font-size: 18px;
    }
}
@media screen and (max-width: 350px) {
    .footer_linkContainer__1Yb50 {
        padding: 0 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/.shared/footer.module.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;AAC3C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,YAAY;IAChB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,sBAAsB;QACtB,QAAQ;IACZ;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,eAAe;QACf,QAAQ;QACR,cAAc;IAClB;IACA;QACI,MAAM;IACV;IACA;QACI,cAAc;QACd,gBAAgB;QAChB,UAAU;QACV,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,OAAO;QACP,sBAAsB;QACtB,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".footer {\n    box-shadow: 0px 0px 10px 10px #0000002b;\n}\n.footerLink {\n    display: flex;\n    align-items: center;\n    gap: 11px;\n}\n\n.copyrightContainer {\n    padding: 11px 0px;\n    background-image: linear-gradient(to right, #2acdc2, #63c15f);\n    margin-top: 28px;\n}\n.copyrightContainer a {\n    text-decoration: none;\n    color: black;\n}\n\n.copyright {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    font-weight: 500;\n    padding: 0 25px;\n}\n.copyright span {\n    font-size: 20px;\n    font-weight: bold;\n}\n\n.linkContainer {\n    display: flex;\n    align-items: center;\n    gap: 28px;\n    justify-content: center;\n    font-size: 20px;\n    font-weight: bold;\n    margin-top: 40px;\n    flex-wrap: wrap;\n}\n.linkContainer p a {\n    text-decoration: none;\n    color: black;\n}\n.linkContainer span {\n    font-size: 33px;\n    position: relative;\n    top: -8px;\n}\n.border1 {\n    display: block;\n    margin: 0px auto;\n    width: 75%;\n    position: relative;\n    top: -12px;\n}\n.border2 {\n    display: none;\n}\n.mainContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10%;\n}\n.call {\n    font-size: 25px;\n    font-weight: bold;\n    color: #69bf4a;\n    margin-bottom: 0;\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.call a {\n    color: #69bf4a;\n    text-decoration: none;\n    cursor: pointer;\n}\n.text {\n    font-size: 25px;\n    font-weight: bold;\n    color: #21ceca;\n    margin-bottom: 0;\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.text a {\n    color: #21ceca;\n    text-decoration: none;\n    cursor: pointer;\n}\n.email {\n    color: #060606;\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 0;\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.email a {\n    color: #060606;\n    text-decoration: none;\n    cursor: pointer;\n}\n.email img {\n    width: 22px;\n    padding-left: 2px;\n}\n.call span, .text span {\n    font-weight: 400;\n    font-size: 18px;\n}\n.pipe {\n    font-size: 12px;\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .copyrightContainer a {\n        transition: color 0.3s ease;\n    }\n    .copyrightContainer a:hover {\n        color: white;    \n    }\n    .linkContainer p a {\n        transition: color 0.3s ease;\n    }\n    .linkContainer p a:hover {\n        color: #21ceca;\n    }\n}\n\n@media (hover: none) and (pointer: coarse) {\n    .copyrightContainer a:active {\n        color: white;\n    }\n    .linkContainer p a:active {\n        color: #21ceca;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .logo {\n        width: 22%;\n    }\n    .pipe {\n        display: none;\n    }\n    .copyright {\n        font-size: 12px;\n        flex-direction: column;\n        gap: 5px;\n    }\n    .copyrightText {\n        font-size: 12px;\n        text-align: center;\n    }\n    .linkContainer {\n        font-size: 14px;\n        padding: 0 60px;\n        gap: 8px;\n        line-height: 0;\n    }\n    .border1 {\n        top: 0;\n    }\n    .border2 {\n        display: block;\n        margin: 0px auto;\n        width: 75%;\n        position: relative;\n        margin-top: 21px;\n    }\n    .mainContainer {\n        gap: 6%;\n        flex-direction: column;\n        margin-top: 16px;\n    }\n    .centerLine {\n        display: none;\n    }\n    .call, .text, .email {\n        font-size: 18px;\n    }\n}\n@media screen and (max-width: 350px) {\n    .linkContainer {\n        padding: 0 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `footer_footer__cN8rv`,
	"footerLink": `footer_footerLink__g658r`,
	"copyrightContainer": `footer_copyrightContainer__lkRt8`,
	"copyright": `footer_copyright__QfEx5`,
	"linkContainer": `footer_linkContainer__1Yb50`,
	"border1": `footer_border1__SlegL`,
	"border2": `footer_border2__E4q0u`,
	"mainContainer": `footer_mainContainer__MJOLd`,
	"call": `footer_call__zE3uC`,
	"text": `footer_text__mNIpU`,
	"email": `footer_email__EGu1B`,
	"pipe": `footer_pipe__n5Pnj`,
	"logo": `footer_logo__Iuxzz`,
	"copyrightText": `footer_copyrightText__FoVj0`,
	"centerLine": `footer_centerLine__567Rs`
};
export default ___CSS_LOADER_EXPORT___;
